import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "langSelector flex-container-row gap20 align-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "badge-container" }
const _hoisted_5 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_currency_selector = _resolveComponent("currency-selector")!
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_badge = _resolveComponent("badge")!
  const _component_language_selector = _resolveComponent("language-selector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSmallScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    (_ctx.showLogOff && !_ctx.isSmallScreen && _ctx.fullName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/partner/account",
            class: "dark-header-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.fullName), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_currency_selector, { key: 2 }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(_component_k_button, {
        onClick: _withModifiers(_ctx.onClickShoppingCart, ["prevent"]),
        title: _ctx.localize('showShoppingCart'),
        class: "icon-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_my_icon, {
            icon: "cart",
            size: 20
          })
        ]),
        _: 1
      }, 8, ["onClick", "title"]),
      _createVNode(_component_badge, { rounded: "full" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.shoppingCartItemCount), 1)
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.shoppingCartItemCount > 0]
    ]),
    _createVNode(_component_language_selector),
    (!_ctx.isSmallScreen && _ctx.showLogOff)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/logoff",
            class: "dark-header-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('LogOff')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}